// Translator notes: Phase 5 items 2 and 4: focus particles (engine/src/particles.ts), the Finnish lexical bridge
// (finnish-bridge.ts).
// Each id is an engine note (`notes.add(text, id, args)`); `args` names its arguments in the order the
// strings take them. Collected by translator/notes.ts (import.meta.glob): adding a note means adding it here.
import { defineNotes } from '../note-defs';

export const notes = defineNotes({
  focusParticle: {
    args: ['word', 'hv'],
    fi: (a: string[]) => `”${a[0]}” käännettiin painottavalla sanalla ${a[1]}.`,
    en: (a: string[]) => `“${a[0]}” was translated with the focus word ${a[1]}.`,
  },
  fiBridge: {
    args: ['word', 'en', 'hv'],
    fi: (a: string[]) => `Sanaa ”${a[0]}” ei löytynyt sanakirjan suomenkielisistä merkityksistä, joten se haettiin englannin sanan ”${a[1]}” kautta: ${a[2]}.`,
    en: (a: string[]) => `“${a[0]}” is not among the dictionary's Finnish meanings, so it was looked up through the English “${a[1]}”: ${a[2]}.`,
  },
});

declare module '../note-defs' {
  interface NoteIds extends Record<keyof typeof notes, true> {}
}
